
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import 'primereact/resources/themes/nova-accent/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Card } from "primereact/card";
import { Modal, Form, Col, Row, Button as ReactButton } from 'react-bootstrap';
import { handleRequest } from '../../redux/config/env';
import { Form as FormAnt, InputNumber } from 'antd';
import { FormattedMessage } from "react-intl";
import 'react-contexify/dist/ReactContexify.min.css';
import { Item, MenuProvider } from 'react-contexify';
import CustomMaterialMenu from '../settings/ForComponents/CustomMaterialMenu';
import HowtoUse from '../standardization/HowtoUse';
import Settings from '../standardization/Settings';
import Whatis from '../standardization/Whatis';
import { Table, Input, Select, Radio, Checkbox, Button as AntButton, Divider } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

const { Column } = Table;
const { Option } = Select;
export class ArchivingWorkflow extends Component {

    constructor() {
        super();
        this.state = {
            modalDeleteShow: false,
            hideInputs: true,
            hideSave: false,
            hideUpdate: true,

            archivingWorkflowList: [],

            stockSelectItems: [],
            archiveList: [{ id:0, archivingTypeId: null, methodOfTransferId: null, archiveOrder: 0, stockId: null, detentionPeriod: 0, detentionPeriodType: "", dispose: false, disposingMethodId: null, active: true }],
            archivingType: null,
            folderName: "",
            folderCode: "",
            serialOfRecords: false,
            codeSerialNumber: false,
            codeName: '',
            archivingTypeSelectItems: [],
            methodOfTransfer: '',
            methodOfTransferSelectItems: [],
            disposingMethod: '',
            disposingMethodSelectItems: [],
            documentSelectItems: [],
            archivingWorkflowId:0,

            dynamicAttributes: [],
            authorizations: [],
            Inputs: [],
            isAdmin: false,
            howToUseSetting: false,
            whatIsSetting: false,

            formId: null
        };
        // this.actionTemplate = this.actionTemplate.bind(this);
        // this.showSuccess = this.showSuccess.bind(this);
        // this.showError = this.showError.bind(this);
        // this.showWarning = this.showWarning.bind(this);

    }

    formRef = React.createRef();


    componentDidMount = async () => {
        this.getDynamicMenu();
        this.fillCodes();

        if (this.props.auth !== undefined)
            if (this.props.auth.user !== null) {

                this.setState({
                    isAdmin: this.props.auth.user.userType === 2 ? true : false
                });

            }

        this.setStandardizations();
        this.setComboboxes();
        this.restartTable();


    }

    save = async () => {

        var archiveList = this.state.archiveList;

        archiveList.forEach(element => {

            if (element.id < 0)
                element.id = 0; 
            
            element.stockId=null; // TODO stock sayfası tamamlanınca değişecek.

        });

        const obj = {
            id: this.state.archivingWorkflowId,
            documentLogId: this.state.documentId,
            archivingType: this.state.archivingType,
            folderName: this.state.folderName,
            folderCode: this.state.folderCode,
            codeSerialNumber: this.state.codeSerialNumber,
            serialOfRecords: this.state.serialOfRecords,
            archiveList: archiveList

        }

        console.log(obj);
        if (obj.id === 0)
            await handleRequest("POST", "/ArchiveDocument/add", obj);
        else
            await handleRequest("POST", "/ArchiveDocument/update", obj);

        this.showSuccess();
        this.resetInputs();
        this.restartTable();

    }

    edit = (row) => {

        this.setState({
            archivingWorkflowId: row.id,
            documentId: row.documentLogId,
            archivingType: row.archivingType, 
            folderName: row.folderName,
            folderCode: row.folderCode,
            codeSerialNumber: row.codeSerialNumber,
            serialOfRecords: row.serialOfRecords,
            archiveList: row.archiveList,
            hideSave: true,
            hideUpdate: false,
            hideInputs: false,

        });

    }


    delete = async () => {
        const obj = {
            id: this.state.archivingWorkflowId
        }

        await handleRequest("POST", "/ArchiveDocument/delete", obj);

        this.restartTable();
        this.showSuccess();
        this.showOrHideDeleteModal();
    }

    deleteModal = (row) => {
        this.setState({
            modalDeleteShow: true,
            archivingWorkflowId: row.id
        });
    }

    showOrHideDeleteModal = () => {
        this.setState({
            modalDeleteShow: !this.state.modalDeleteShow
        });

        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }



    showSuccess(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageSuccess1" defaultMessage="Successfull" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Success"
        });
    }

    showError(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageError1" defaultMessage="An error was occured please try again later !" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Error"
        });
    }

    showWarning(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageCheckInputs" defaultMessage="Something went wrong. Please check inputs." />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Warning"
        });
    };




    actionTemplate(rowData, column) {


        return <React.Fragment>
            <CustomMaterialMenu row={rowData} onDeleteRow={this.deleteModal.bind(this)} onEditRow={this.edit.bind(this)} />
        </React.Fragment>;


    }


    restartTable = async () => {
        const response = await handleRequest("GET", "/ArchiveDocument/getAllByCompany");

        if (response.data.length !== 0) {
            const list = response.data;
            list.forEach(element => {
                element.key = element.id
            });
            this.setState({
                archivingWorkflowList: list,
            });
        }

        if (response.data.length === 0) {
            this.setState({
                archivingWorkflowList: [],
            });
        }
    }


    setComboboxes = async () => {
        const resDepList = await handleRequest("GET", "/DocumentLog/getAll");
        if (resDepList.data.length > 0) {
            this.setState({
                documentSelectItems: resDepList.data
            });
        } else {
            this.setState({
                documentSelectItems: []
            });
        }

        const resStockList = await handleRequest("GET", "/StockSectionLog/getAll");
        if (resStockList.data.length > 0) {
            this.setState({
                stockSelectItems: resStockList.data
            });
        } else {
            this.setState({
                stockSelectItems: [{ id: 1, sectionDescription: "Stock 1" }]
            });
        }


    }
    setStandardizations = async () => {
        const responseDP = await handleRequest("POST", "/DynamicPage/getFormAttributes", { pageName: "ArchivingWorkflow" });
        if (responseDP.data.length > 0) {
            this.setState({
                dynamicAttributes: responseDP.data
            });
        } else {
            this.setState({
                dynamicAttributes: []
            });
        }

        const obj = {
            pageName: "ArchivingWorkflow"
        };

        const responseInputs = await handleRequest("POST", "/DynamicInputs/getResult", obj);
        if (responseInputs.data.length !== 0) {
            this.setState({
                Inputs: responseInputs.data,
            });
        } else {
            this.setState({
                Inputs: [],
            });
        }

        //const menuObj = this.props.auth.user.authList.find(p => Boolean(p.dynamicMenu) && p.dynamicMenu.page === "ArchivingWorkflow");

        try {
            this.setState({
                authorizations: this.props.auth.user.authList.filter(p => p.menuId === this.state.formId || p.form === "All")
            });

        } catch (error) {

        }

    }



    getDynamicMenu = async () => {
        const responseTree = await handleRequest("GET", "/DynamicMenu/getTreeModel");
        if (responseTree.data.length !== 0) {
            var element = responseTree.data.treeTable;

            for (let index = 0; index < element.length; index++) {
                var result = this.searchTree(element[index], this.props.location.pathname.split("/").pop());

                if (result !== null)
                    break;
            }

            this.setState({
                formId: result.data.id
            });

            this.getUserSettings();
        } else {
            this.setState({
                formId: null
            });
        }
    }





    createNew = () => {

        this.setState({
            archivingWorkflowId:0,
            archiveList: [{ id:0, archivingTypeId: null, methodOfTransferId: null, archiveOrder: 0 , stockId: null, detentionPeriod: 0, detentionPeriodType: "", dispose: false, disposingMethodId: null, active: true }],
            archivingType: null,
            folderName: "",
            folderCode: "",
            serialOfRecords: false,
            codeSerialNumber: false,
            codeName: '',           
            methodOfTransfer: '',
            disposingMethod: '',
            modalDeleteShow: false,
            hideSave: false,
            hideUpdate: true,
            hideInputs: false
        });

    }


    stop = () => {

        this.setState({

            archivingWorkflowId:0,
            archiveList: [{ id:0, archivingTypeId: null, methodOfTransferId: null, archiveOrder: 0 , stockId: null, detentionPeriod: 0, detentionPeriodType: "", dispose: false, disposingMethodId: null, active: true }],
            archivingType: null,
            folderName: "",
            folderCode: "",
            serialOfRecords: false,
            codeSerialNumber: false,
            codeName: '',
            methodOfTransfer: '',
            disposingMethod: '',
            modalDeleteShow: false,
            hideInputs: true,
            hideSave: false,
            hideUpdate: true,
        });

    }

    resetInputs = () => {
        this.setState({
            archivingWorkflowId:0,
            archiveList: [{ id:0, archivingTypeId: null, methodOfTransferId: null, archiveOrder: 0 , stockId: null, detentionPeriod: 0, detentionPeriodType: "", dispose: false, disposingMethodId: null, active: true }],
            archivingType: null,
            folderName: "",
            folderCode: "",
            serialOfRecords: false,
            codeSerialNumber: false,
            codeName: '',
            methodOfTransfer: '',
            disposingMethod: '',
            modalDeleteShow: false,
            hideSave: false,
            hideUpdate: true,


        });
    }


    cancel = () => {

        this.resetInputs();
    }





    searchTree = (element, matchingTitle) => {
        if (element.data.page == matchingTitle) {
            return element;
        } else if (element.children != null) {
            var i;
            var result = null;
            for (i = 0; result == null && i < element.children.length; i++) {
                result = this.searchTree(element.children[i], matchingTitle);
            }
            return result;
        }
        return null;
    }





    getUserSettings = async () => {
        const responseUserSettings = await handleRequest("GET", "/UserPageSettings/getFindByFormAndUserId/" + this.state.formId);
        if (responseUserSettings.data.length !== 0) {
            this.setState({
                userSettings: responseUserSettings.data,
                howToUseSetting: responseUserSettings.data.howToUseSetting,
                whatIsSetting: responseUserSettings.data.whatIsSetting
            });
        } else {
            this.setState({

                howToUseSetting: false,
                whatIsSetting: false
            });
        }
    }


    showOrHideModalMessage = () => {
        this.setState({
            modalMessage: !this.state.modalMessage,
        });
        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }

    addCode = async (pType) => {
        const { codeName } = this.state;


        if (codeName.length > 0) {

            const newItem = {
                name: codeName,
                type: pType
            }

            await handleRequest("POST", "/Code/add", newItem);


            this.setState({

                codeName: '',
            });

            this.fillCodes();
        }

    };

    addCodeArchivingType = async () => {
        const { codeName } = this.state;
        let pType = "archivingType";

        if (codeName.length > 0) {

            const newItem = {
                name: codeName,
                type: pType
            }

            await handleRequest("POST", "/Code/add", newItem);


            this.setState({

                codeName: '',
            });

            this.fillCodes();
        }

    };

    addCodeDisposingMethod = async () => {
        const { codeName } = this.state;
        let pType = "disposingMethod";

        if (codeName.length > 0) {

            const newItem = {
                name: codeName,
                type: pType
            }

            await handleRequest("POST", "/Code/add", newItem);


            this.setState({

                codeName: '',
            });

            this.fillCodes();
        }

    };

    addCodeMethodOfTransfer = async () => {
        const { codeName } = this.state;
        let pType = "methodOfTransfer";

        if (codeName.length > 0) {

            const newItem = {
                name: codeName,
                type: pType
            }

            await handleRequest("POST", "/Code/add", newItem);


            this.setState({

                codeName: '',
            });

            this.fillCodes();
        }

    };

    fillCodes = async () => {

        const response = await handleRequest("GET", "/Code/type/archivingType");

        if (response.data !== null && response.data !== undefined) {
            this.setState({
                archivingTypeSelectItems: response.data
            });
        }

        const response2 = await handleRequest("GET", "/Code/type/disposingMethod");

        if (response2.data !== null && response2.data !== undefined) {
            this.setState({
                disposingMethodSelectItems: response2.data
            });
        }

        const response3 = await handleRequest("GET", "/Code/type/methodOfTransfer");

        if (response3.data !== null && response3.data !== undefined) {
            this.setState({
                methodOfTransferSelectItems: response3.data
            });
        }
    }

    addNewArchive = () => {

        const list = this.state.archiveList;
        let obj = { id: list.length * -1, archivingTypeId: null, methodOfTransferId: null, archiveOrder: list.length, stockId: null, detentionPeriod: 0, detentionPeriodType: "", dispose: false, disposingMethodId: null, active: true }; list.push(obj);
        this.setState({
            archiveList: list
        });

    }

    deleteArchiveItem = (item) => {

        const list = this.state.archiveList;

        list[list.findIndex(p => p.id === item.id)].active = false;

        list.filter(p => p.active === true).forEach((element, index) => {
            element.archiveOrder = index;
        });
        this.setState({
            archiveList: list
        });

    }

    render() {

        const onFinish = values => {
            console.log('Success:', values);
        };

        const onFinishFailed = errorInfo => {
            console.log('Failed:', errorInfo);
        };

        const layout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };


        return <div>

                <MenuProvider id="menu_id">


                    <Modal
                        show={this.state.modalDeleteShow}
                        onHide={this.showOrHideDeleteModal}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">Chosen document type will be deleted !</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Are you sure?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <ReactButton variant="secondary" onClick={this.showOrHideDeleteModal}>Cancel</ReactButton>
                            <ReactButton variant="danger" onClick={this.delete} >Delete</ReactButton>
                        </Modal.Footer>
                    </Modal>

                    <Card>

                        <div>
                            <Row>
                                <Col sm="1">
                                    <Settings formId={this.state.formId} onSaveChanges={this.getUserSettings.bind(this)} ></Settings>

                                </Col>
                                <Col sm="10">
                                </Col>
                                <Col sm="1" style={{ textAlign: "right" }}>
                                    {!this.state.howToUseSetting && <HowtoUse formId={this.state.formId} ></HowtoUse>

                                    }
                                </Col>
                            </Row>
                        </div>

                        <div>
                            <Row>
                                <Col sm="10">
                                </Col>
                                <Col sm="2">
                                    {/*<Button style={{ width: '100%' }} id='create-new' icon="pi pi-plus" onClick={this.createNew} label="Create New" />*/}
                                    {this.state.hideInputs &&
                                        <ReactButton id="OrganizationalLevelCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="primary" onClick={this.createNew}><FormattedMessage id="GeneralButtonCreateNew" defaultMessage="Create New" /></ReactButton>
                                    }

                                    {!this.state.hideInputs &&
                                        <ReactButton id="OrganizationalLevelCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="danger" onClick={this.stop}><FormattedMessage id="GeneralButtonStopProcess" defaultMessage="Stop the process" /></ReactButton>
                                    }

                                </Col>
                            </Row>
                        </div>

                        <div hidden={this.state.hideInputs} style={{ marginBottom: '2rem' }}>

                            <FormAnt
                                {...layout}
                                initialValues={{ remember: false }}
                                onFinish={this.save}
                                onFinishFailed={onFinishFailed}
                                ref={this.formRef}
                            >

                                

                                {
                                    <FormAnt.Item
                                        label={<FormattedMessage id="todo" defaultMessage="Documented Info" />}
                                        name="OrganizationalLevelDesignation"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type description" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                                <Select placeholder="" value={this.state.documentId} onChange={(value) => {
                                                    this.setState({
                                                        documentId: value
                                                    })
                                                }}
                                                >
                                                    <Option key={0} value={0}>Select</Option>
                                                    {this.state.documentSelectItems.map(i => (
                                                        <Option key={i.id} value={i.id}>{i.description}</Option>
                                                    ))}
                                                </Select>


                                            </Col>
                                            <Col sm="6">
                                            </Col>
                                        </Form.Group>
                                    </FormAnt.Item>
                                }

                                {
                                    <FormAnt.Item
                                        label={""}
                                        name="OrganizationalLevelDesignation"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type description" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                            </Col>
                                            <Col sm="6">

                                                <div>
                                                    <Checkbox onChange={(e) => {
                                                        this.setState({
                                                            serialOfRecords: e.target.checked
                                                        })
                                                    }} checked={this.state.serialOfRecords}> Serial Of records </Checkbox>
                                                </div>


                                            </Col>

                                        </Form.Group>
                                    </FormAnt.Item>
                                }

                                {
                                    <FormAnt.Item
                                        label={<FormattedMessage id="todo" defaultMessage="Archiving" />}
                                        name="OrganizationalLevelDesignation"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select type" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                                <Radio.Group onChange={(e) => {
                                                    this.setState({
                                                        archivingType: e.target.value
                                                    })
                                                }} value={this.state.archivingType}>
                                                    <Radio value={1}>Folder</Radio>
                                                    <Radio value={2}>Only Electronic Copy</Radio>
                                                </Radio.Group>

                                            </Col>
                                            <Col sm="6">
                                            </Col>
                                        </Form.Group>
                                    </FormAnt.Item>
                                }

                                {Boolean(this.state.archivingType) && this.state.archivingType === 1 &&
                                    <FormAnt.Item
                                        label={<FormattedMessage id="todo" defaultMessage="Folder Name" />}
                                        name="OrganizationalLevelDesignation"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type description" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                                <Input id="todo" value={this.state.folderName} onChange={(e) => this.setState({ folderName: e.target.value })} />
                                            </Col>
                                            <Col sm="6">
                                            </Col>
                                        </Form.Group>
                                    </FormAnt.Item>
                                }

                                {Boolean(this.state.archivingType) && this.state.archivingType === 1 &&
                                    <FormAnt.Item
                                        label={<FormattedMessage id="todo" defaultMessage="Folder Code" />}
                                        name="OrganizationalLevelDesignation"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type description" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                                <Input id="todo" value={this.state.folderCode} onChange={(e) => this.setState({ folderCode: e.target.value })} />
                                            </Col>
                                            <Col sm="6">
                                                <div>
                                                    <Checkbox onChange={(e) => {
                                                        this.setState({
                                                            codeSerialNumber: e.target.checked
                                                        })
                                                    }} checked={this.state.codeSerialNumber}> Ascending serial numbers </Checkbox>
                                                </div>
                                            </Col>
                                        </Form.Group>
                                    </FormAnt.Item>
                                }

                                {Boolean(this.state.archivingType) && this.state.archivingType === 1 && this.state.archiveList.filter(p => p.active === true).map((item, index) => (
                                    <div style={{ backgroundColor: "white", padding: "10px", marginTop: "10px", border: '1px solid #1ab394' }}>

                                        {  <FormAnt.Item
                                            label={<FormattedMessage id="todo" defaultMessage="Archiving Type" />}
                                            name="OrganizationalLevelDesignation"
                                            rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select status" /> }]} >


                                            <Form.Group key={item.id} style={{ marginBottom: '1rem' }} as={Row} >
                                                <Col sm="6">
                                                    <Select
                                                        style={{ width: '180px' }}
                                                        placeholder="Unit"
                                                        value={item.archivingTypeId} onChange={(value) => {
                                                            this.setState(prevState => ({
                                                                archiveList: prevState.archiveList.map(
                                                                    el => el.id === item.id ? { ...el, archivingTypeId: value } : el
                                                                )
                                                            }))
                                                        }}


                                                        dropdownRender={menu => (
                                                            <div>
                                                                {menu}
                                                                <Divider style={{ margin: '4px 0' }} />
                                                                <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                                                    <Input style={{ flex: 'auto' }} value={this.state.codeName} onChange={(event) => {
                                                                        this.setState({
                                                                            codeName: event.target.value,
                                                                        });
                                                                    }} />
                                                                    <a
                                                                        style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                                                        onClick={this.addCodeArchivingType}
                                                                    >
                                                                        <PlusOutlined /> Add item
                                                               </a>
                                                                </div>
                                                            </div>
                                                        )}
                                                    >
                                                        {this.state.archivingTypeSelectItems.map(i => (
                                                            <Option key={i.id} value={i.id}>{i.name}</Option>
                                                        ))}
                                                    </Select>


                                                </Col>
                                                <Col sm="5">
                                                </Col>
                                                <Col sm="1">
                                                    {index > 0 && <AntButton type="dashed" onClick={() => this.deleteArchiveItem(item)} shape="circle" icon={<CloseOutlined />} />}
                                                </Col>

                                            </Form.Group>

                                        </FormAnt.Item>}

                                        {index > 0 && <FormAnt.Item
                                            label={<FormattedMessage id="todo" defaultMessage="Method of transfer from previous" />}
                                            name="OrganizationalLevelDesignation"
                                            rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select status" /> }]} >

                                            <Form.Group key={item.id} style={{ marginBottom: '1rem' }} as={Row} >
                                                <Col sm="6">
                                                    <Select
                                                        style={{ width: '180px' }}
                                                        placeholder="Unit"
                                                        value={item.methodOfTransferId} onChange={(value) => {
                                                            this.setState(prevState => ({
                                                                archiveList: prevState.archiveList.map(
                                                                    el => el.id === item.id ? { ...el, methodOfTransferId: value } : el
                                                                )
                                                            }))
                                                        }}


                                                        dropdownRender={menu => (
                                                            <div>
                                                                {menu}
                                                                <Divider style={{ margin: '4px 0' }} />
                                                                <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                                                    <Input style={{ flex: 'auto' }} value={this.state.codeName} onChange={(event) => {
                                                                        this.setState({
                                                                            codeName: event.target.value,
                                                                        });
                                                                    }} />
                                                                    <a
                                                                        style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                                                        onClick={this.addCodeMethodOfTransfer}
                                                                    >
                                                                        <PlusOutlined /> Add item
                                                               </a>
                                                                </div>
                                                            </div>
                                                        )}
                                                    >
                                                        {this.state.methodOfTransferSelectItems.map(i => (
                                                            <Option key={i.id} value={i.id}>{i.name}</Option>
                                                        ))}
                                                    </Select>


                                                </Col>

                                            </Form.Group>

                                        </FormAnt.Item>}

                                        {
                                            <FormAnt.Item
                                                label={<FormattedMessage id="todo" defaultMessage="Archive (Stock)" />}
                                                name="OrganizationalLevelDesignation"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select status" /> }]} >


                                                <Form.Group style={{ marginBottom: '1rem' }} as={Row} >
                                                    <Col sm="6">
                                                        <Select
                                                            style={{ width: '180px' }}
                                                            placeholder="Unit"
                                                            value={item.stockId} onChange={(value) => {
                                                                this.setState(prevState => ({
                                                                    archiveList: prevState.archiveList.map(
                                                                        el => el.id === item.id ? { ...el, stockId: value } : el
                                                                    )
                                                                }))
                                                            }}


                                                        >
                                                            {this.state.stockSelectItems.map(i => (
                                                                <Option key={i.id} value={i.id}>{i.sectionDescription}</Option>
                                                            ))}
                                                        </Select>


                                                    </Col>

                                                </Form.Group>

                                            </FormAnt.Item>
                                        }

                                        {
                                            <FormAnt.Item
                                                label={<FormattedMessage id="todo" defaultMessage="Detention Period" />}
                                                name="OrganizationalLevelDesignation"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select status" /> }]} >


                                                <Form.Group style={{ marginBottom: '1rem' }} as={Row} >

                                                    <Col sm="3">
                                                        <InputNumber min={1}
                                                            onChange={(value) => {
                                                                this.setState(prevState => ({
                                                                    archiveList: prevState.archiveList.map(
                                                                        el => el.id === item.id ? { ...el, detentionPeriod: value } : el
                                                                    )
                                                                }))
                                                            }}
                                                        > </InputNumber> 


                                                    </Col>

                                                    <Col sm="3">
                                                        <Select style={{ width: '100%' }} placeholder="Workflow" value={item.detentionPeriodType}
                                                            onChange={(value) => {
                                                                this.setState(prevState => ({
                                                                    archiveList: prevState.archiveList.map(
                                                                        el => el.id === item.id ? { ...el, detentionPeriodType: value } : el
                                                                    )
                                                                }))
                                                            }}
                                                        >
                                                            <Option key={""} value={""}>{"Select"}</Option>
                                                            <Option key={"year"} value={"year"}>{"Year"}</Option>
                                                            <Option key={"month"} value={"month"}>{"Month"}</Option>
                                                            <Option key={"week"} value={"week"}>{"Week"}</Option>
                                                            <Option key={"day"} value={"day"}>{"Day"}</Option>

                                                        </Select>

                                                    </Col>

                                                </Form.Group>

                                            </FormAnt.Item>
                                        }

                                        {
                                            <FormAnt.Item
                                                label={""}
                                                name="OrganizationalLevelDesignation"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select status" /> }]} >


                                                <Form.Group style={{ marginBottom: '1rem' }} as={Row} >

                                                    <Col sm="6">
                                                    </Col>
                                                    <Col sm="6">
                                                        <div>
                                                            <Checkbox onChange={(e) => {
                                                                this.setState(prevState => ({
                                                                    archiveList: prevState.archiveList.map(
                                                                        el => el.id === item.id ? { ...el, dispose: e.target.checked } : el
                                                                    )
                                                                }))
                                                            }} checked={item.dispose}> Dispose after detention period </Checkbox>
                                                        </div>

                                                    </Col>

                                                </Form.Group>

                                            </FormAnt.Item>}

                                        {item.dispose && <FormAnt.Item
                                            label={<FormattedMessage id="todo" defaultMessage="Disposing method" />}
                                            name="OrganizationalLevelDesignation"
                                            rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select status" /> }]} >

                                            <Form.Group key={item.id} style={{ marginBottom: '1rem' }} as={Row} >
                                                <Col sm="6">
                                                    <Select
                                                        style={{ width: '180px' }}
                                                        placeholder="Unit"
                                                        value={item.disposingMethodId} onChange={(value) => {
                                                            this.setState(prevState => ({
                                                                archiveList: prevState.archiveList.map(
                                                                    el => el.id === item.id ? { ...el, disposingMethodId: value } : el
                                                                )
                                                            }))
                                                        }}


                                                        dropdownRender={menu => (
                                                            <div>
                                                                {menu}
                                                                <Divider style={{ margin: '4px 0' }} />
                                                                <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                                                    <Input style={{ flex: 'auto' }} value={this.state.codeName} onChange={(event) => {
                                                                        this.setState({
                                                                            codeName: event.target.value,
                                                                        });
                                                                    }} />
                                                                    <a
                                                                        style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                                                        onClick={this.addCodeDisposingMethod}
                                                                    >
                                                                        <PlusOutlined /> Add item
                                                               </a>
                                                                </div>
                                                            </div>
                                                        )}
                                                    >
                                                        {this.state.disposingMethodSelectItems.map(i => (
                                                            <Option key={i.id} value={i.id}>{i.name}</Option>
                                                        ))}
                                                    </Select>


                                                </Col>

                                            </Form.Group>

                                        </FormAnt.Item>}

                                        {
                                            <FormAnt.Item

                                                name="OrganizationalLevelDesignation"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select status" /> }]} >


                                                <Form.Group style={{ marginBottom: '1rem' }} as={Row} >

                                                    <Col sm="10">

                                                    </Col>
                                                    <Col sm="2">
                                                        <AntButton type="primary" onClick={this.addNewArchive} icon={<PlusOutlined />}></AntButton>

                                                    </Col>

                                                </Form.Group>

                                            </FormAnt.Item>}


                                    </div>
                                ))}





                                <div hidden={this.state.hideSave}>
                                    {
                                        <Row>
                                            <Col sm="3">
                                            </Col>
                                            <Col sm="5">
                                                {/*<Button style={{ width: '100%' }} id='save-orgLevel' className="p-button-success" onClick={this.saveOrganizationalLevel} label="Save" />*/}
                                                <ReactButton id="OrganizationalLevelSaveButton" type="submit" style={{ width: '100%', marginTop: "10px" }}
                                                    variant="success" ><FormattedMessage id="GeneralButtonSave" defaultMessage="Save" /></ReactButton>
                                            </Col>
                                            <Col sm="3">
                                            </Col>
                                        </Row>
                                    }
                                </div>



                                <div hidden={this.state.hideUpdate}>
                                    {
                                        <Row>
                                            <Col sm="3">
                                            </Col>
                                            <Col sm="2">
                                                {/*<Button style={{ width: '100%' }} id='cancel-orgLevel' onClick={this.changeButtonCancel} className="p-button-danger" label="Cancel" />*/}
                                                <ReactButton id="OrganizationalLevelCancelButton" style={{ width: '100%', marginTop: "10px" }} variant="secondary" onClick={this.cancel}>
                                                    <FormattedMessage id="GeneralButtonCancel" defaultMessage="Cancel" /></ReactButton>
                                            </Col>
                                            <Col sm="3">
                                                {/*<Button style={{ width: '100%' }} id='update-orgLevel' onClick={this.updateDone} className="p-button-warning" label="Update" />*/}
                                                <ReactButton id="OrganizationalLevelUpdateButton" style={{ width: '100%', marginTop: "10px" }} variant="warning" type="submit">
                                                    <FormattedMessage id="GeneralButtonUpdate" defaultMessage="Update" /></ReactButton>
                                            </Col>
                                            <Col sm="3">
                                            </Col>
                                        </Row> 
                                    }
                                </div>
                                <Modal
                                    show={this.state.modalMessage}
                                    onHide={this.showOrHideModalMessage}
                                    backdrop="static"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>

                                    <Modal.Header closeButton>
                                        <Modal.Title id="contained-modal-title-vcenter">
                                            <Row >
                                                <Col sm="12">
                                                    {this.state.messageTip == "Success" &&
                                                        <i className="fas fa-check fa-2x" style={{ color: '#00ff2a' }} />}

                                                    {this.state.messageTip == "Warning" &&
                                                        <i className="fas fa-exclamation-circle fa-2x" style={{ color: '#faca2a' }} />}

                                                    {this.state.messageTip == "Error" &&
                                                        <i className="fas fa-times fa-2x" style={{ color: '#ff0400' }} />}
                                                </Col>
                                            </Row>
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body>
                                        <Row >
                                            <Col sm="12">
                                                {this.state.message}
                                            </Col>
                                        </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <ReactButton variant="secondary" onClick={this.showOrHideModalMessage}><FormattedMessage id="GeneralTextClose" defaultMessage="Close" /></ReactButton>
                                    </Modal.Footer>
                                </Modal>
                            </FormAnt>
                        </div>

                        {this.state.archivingWorkflowList.length > 0 && <Table style={{ marginTop: '3rem' }} size={`small`} dataSource={this.state.archivingWorkflowList} bordered scroll={{ x: 800, scrollToFirstRowOnChange: true }} >


                            <Column title="S/N" dataIndex="index" />

                            <Column title="Stock" render={(value, row, index) => {

                                if (Boolean(row.archiveList) && row.archiveList.length > 0 && Boolean(row.archiveList[0].stock)) 
                                    return row.archiveList[0].stock.sectionDescription; 

                            }} />
                            <Column title="Documented Info" render={(value, row, index) => {

                                if (Boolean(row.documentLog))
                                    return row.documentLog.description;

                            }} />
                            <Column title="Preservation" render={(value, row, index) => {

                                if (Boolean(row.archiveList) && row.archiveList.length > 0) {
                                    return row.archiveList[0].detentionPeriod + " " + row.archiveList[0].detentionPeriodType;
                                }

                            }} />
                            <Column title="Folder Name" dataIndex="folderName" />
                            <Column title="Folder Code" dataIndex="folderCode" />
                            <Column title="Volume" dataIndex="volume" />
                            <Column title="Contents" dataIndex="contents" />
                            <Column title="Status" dataIndex="status" />

                            <Column title="Action" render={(value, row, index) => {

                                return this.actionTemplate(row);

                            }} />
                        </Table>}
                    </Card>

               </MenuProvider>
                { Boolean(this.state.whatIsSetting) && !this.state.whatIsSetting && <Whatis  ></Whatis>


                }
            </div>
      
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        i18n: state.i18n
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchivingWorkflow)